import { useState } from "react";
import emailjs from "@emailjs/browser";
import './contact.css';

// EmailJS
const EMAILJS_SERVICE_ID  = "service_c7vfhbm";
const EMAILJS_TEMPLATE_ID = "template_rbh9zto";
const EMAILJS_PUBLIC_KEY  = "kKT1yoxJ1Am98N8n7";

function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'sending' | 'sent' | 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        from_name:  formData.name,
        from_email: formData.email,
        message:    formData.message,
      },
      EMAILJS_PUBLIC_KEY
    ).then(() => {
      setStatus('sent');
      setFormData({ name: '', email: '', message: '' });
    }).catch(() => {
      setStatus('error');
    });
  };

  return (
    <div className="contact-container">
      {/* About Section */}
      <section className="about-section">
        <img src="/self-pic.JPG" alt="Charlie Carroll" className="profile-image" />
        <div className="about-text">
          <h2>About Me</h2>
          <p>I'm Charlie, a senior studying Computer Science with a Software Engineering specialization at IU's Luddy School of Informatics, Computing, and Engineering, alongside a minor in Financial Literacy in Business.<br /><br />
          I thrive in environments where I can quickly identify inefficiencies and develop creative solutions. My work spans full-stack web and iOS mobile development, with a focus on clean interfaces and well-structured, scalable code.<br /><br />
          I'm actively looking to contribute to ambitious teams, continue growing as an engineer, and build software that makes a real impact.</p>
        </div>
      </section>

      {/* Skills Section */}
      <section className="skills-section">
        <h2 className="about-header">My Skills</h2>
        <div className="skills-badges">
          <span className="badge">JavaScript</span>
          <span className="badge">React</span>
          <span className="badge">Swift</span>
          <span className="badge">Python</span>
          <span className="badge">Java</span>
          <span className="badge">Firebase</span>
          <span className="badge">Docker</span>
          <span className="badge">Git</span>
          <span className="badge">Flask</span>
          <span className="badge">Linux</span>
        </div>
      </section>

      {/* Contact Section */}
      <h2 className="about-header">Contact Me</h2>
      <section className="contact-section">

        {/* my contact info */}
        <div className="contact-details">
          <h4 className="form-header">My Info</h4>
          <p>Mobile — <a href="tel:+17737820064">+1 (773) 782-0064</a></p>
          <p>Personal — <a href="mailto:charliecarroll222@gmail.com">charliecarroll222@gmail.com</a></p>
          <p>IU Email — <a href="mailto:chajcarr@iu.edu">chajcarr@iu.edu</a></p>
        </div>

        {/* Contact form */}
        <div className="contact-form-container">
          <h4 className="form-header">Send a Message</h4>
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={status === 'sending'}
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={status === 'sending'}
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              disabled={status === 'sending'}
            />
            <button type="submit" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send Message'}
            </button>
            {status === 'sent' && (
              <p className="form-success">Message sent! I'll get back to you soon.</p>
            )}
            {status === 'error' && (
              <p className="form-error">Something went wrong. Try emailing me directly.</p>
            )}
          </form>
        </div>
      </section>

      {/* Social Links Section */}
      <section className="social-links">
        <a href="https://www.linkedin.com/in/charlie-carroll2/" target="_blank" rel="noopener noreferrer">
          <button className="li-button">LinkedIn</button>
        </a>
        <a href="https://github.com/charliecarroll222" target="_blank" rel="noopener noreferrer">
          <button className="gh-button">GitHub</button>
        </a>
        <a href="https://iubloomington.joinhandshake.com/profiles/bkh6m6" target="_blank" rel="noopener noreferrer">
          <button className="hs-button">Handshake</button>
        </a>
      </section>
    </div>
  );
}

export default Contact;
